import { render, staticRenderFns } from "./ForumList.vue?vue&type=template&id=18340597"
import script from "./ForumList.vue?vue&type=script&lang=js"
export * from "./ForumList.vue?vue&type=script&lang=js"
import style0 from "./ForumList.vue?vue&type=style&index=0&id=18340597&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports